import { InfoSite } from '../types';
import { atom, RecoilState } from 'recoil';


export const infoSite: RecoilState<InfoSite> = atom({
    key: 'infoSite',
    default: {
        Nome: "FotoGallery",
        Colore: {
            Rgba: {
                r: 0,
                g: 102,
                b: 205,
                a: 0.904
            }
        },
        iconaSito: "",
        Regione: {
            Nome: "Emilia Romagnia",
            Url: "https://www.regione.emilia-romagna.it/"
        }
    },
});



export const ImgNameSearch = atom({
    key: "imgNameSearch",
    default: ""
})

export const ImgData: RecoilState<any> = atom({
    key: "ImgData",
    default: []
})


export const ImgYear: RecoilState<number> = atom({
    key: "ImgYear",
    default: 2020
})

export const LayoutView: RecoilState<string> = atom({
    key: "LayoutView",
    default: "cropper1"
})
